import { render, staticRenderFns } from "./productIntroduction.vue?vue&type=template&id=0709ffd0&scoped=true"
import script from "./productIntroduction.vue?vue&type=script&lang=js"
export * from "./productIntroduction.vue?vue&type=script&lang=js"
import style0 from "./productIntroduction.vue?vue&type=style&index=0&id=0709ffd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0709ffd0",
  null
  
)

export default component.exports